import { createSlice } from '@reduxjs/toolkit';
import { createIndependentStore } from '@utils/react';

const initialState = {
  user: void 0
};
const slice = createSlice({
  name: "provider/user-identity",
  initialState,
  reducers: {
    setUser(state, action) {
      state.user = action.payload;
    }
  }
});
const userIdentityStore = createIndependentStore(slice);
const getUserIdentityState = userIdentityStore.getState;
const useUserIdentityState = userIdentityStore.useSelector;

export { getUserIdentityState, slice, useUserIdentityState, userIdentityStore };
//# sourceMappingURL=user-identity.state.js.map
